import { tryReportError } from '@ui/lib/bugsnag';

// FIXME: temp solution, bugs in trading view , https://github.com/tradingview/charting_library/issues/8479, last bar not displaying
// fixings logic: issue happens on 1m,5m,15m only, adding one more bar to the end of the array

/**
 * Converts '&' separator to ',' for TradingView session format
 * Input: "0000-1700&1800-2400" -> Output: "0000-1700,1800-2400"
 */
export const convertSessionSeparator = (session: string): string => {
  return session.replace(/&/g, ',');
};

/**
 * Adjusts a single time range by adding 1 minute to the end time
 * Input: "0000-1700" -> Output: "0000-1701"
 * Note: End time of '2400' is kept as-is since it represents end of day
 */
const adjustSingleTimeRange = (timeRange: string): string => {
  const timePattern = /^(\d{4})-(\d{4})$/;
  const match = timeRange.match(timePattern);

  if (!match) {
    return timeRange;
  }

  const [, start, end] = match;

  // If start and end time are the same, return as is
  if (start === end) {
    return `${start}-${end}`;
  }

  // If end time is 2400 (end of day), don't add 1 minute
  // Adding would result in invalid time '2401'
  if (end === '2400') {
    return `${start}-${end}`;
  }

  const endHours = Math.floor(parseInt(end) / 100);
  const endMinutes = parseInt(end) % 100;

  // Handle minute rollover
  let newEndHours = endHours;
  let newEndMinutes = endMinutes + 1;

  if (newEndMinutes >= 60) {
    newEndHours += 1;
    newEndMinutes = 0;
  }

  const newEndTime = newEndHours * 100 + newEndMinutes;

  return `${start}-${newEndTime.toString().padStart(4, '0')}`;
};

export const formatSessionTime = ({
  session,
  symbolName,
}: {
  session?: string;
  symbolName?: string;
}): string => {
  if (!session) return '24x7';

  // Handle multiple time ranges separated by '&' (e.g., "0000-1700&1800-2400")
  // TradingView uses ',' to separate multiple sessions within a day
  const timeRanges = session.split('&');
  const timePattern = /^\d{4}-\d{4}$/;

  // Validate all time ranges
  const allValid = timeRanges.every((range) => timePattern.test(range.trim()));

  if (!allValid) {
    tryReportError(
      new Error(`Miss the session handling case ${symbolName}`, {
        cause: session,
      }),
    );
    
return session;
  }

  // Adjust each time range and join with ',' for TradingView format
  return timeRanges.map((range) => adjustSingleTimeRange(range.trim())).join(',');
};
